import { SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { useShallow } from 'zustand/react/shallow';

import { useQualityFormulaStore } from '../store/QualityFormulaStoreProvider';
import { ImpactCard } from './ImpactCard';
import { SummaryCard } from './SummaryCard';

/** Renders nothing until a formula has actually been tested — there is no placeholder state, since
 * the Test These Formulas button is the only way results ever appear. */
export const QualityResultsSection: React.FC = () => {
  const { results, summary } = useQualityFormulaStore(
    useShallow(store => ({ results: store.results, summary: store.summary })),
  );
  if (results.length === 0 || summary === null) return null;

  return (
    <Stack aria-label="Formula test results" component="section" gap="md">
      <Stack gap={4}>
        <Title order={2} size="h4">
          Review Results
        </Title>
        <Text c="dimmed" fz="sm" maw={640}>
          See exactly how each quality spec changes price or delivered quantity, side by side.
        </Text>
      </Stack>

      <SimpleGrid cols={{ base: 1, lg: 3, sm: 2 }} spacing="md">
        <SummaryCard summary={summary} />
        {results.map(result => (
          <ImpactCard key={result.id} result={result} />
        ))}
      </SimpleGrid>
    </Stack>
  );
};
